import { useState } from "react"
import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import type { TenantFragment } from "@/v2-backoffice-client/tenant/__types__/tenant.fragment"
import MigrationCenterDialog from "@/v2-backoffice-client/tenant/migration/center/MigrationCenterDialog"

export type TenantMigrateMenuItemProps = Omit<
  ActionMenuItemProps,
  "onClick"
> & {
  tenant: TenantFragment
}

// Row-menu entry to the Migration Center scoped to this one team (FUS-927):
// the same center the toolbars open, so sends can never drift by surface.
function TenantMigrateMenuItem(props: TenantMigrateMenuItemProps) {
  const { tenant, children, ...menuItemProps } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <ActionMenu.Item
        iconSrc="key"
        data-feature-code="UI_BackofficeTenants_Row_FusionLogin"
        onSelect={(e) => {
          e.preventDefault()
          setIsOpen(true)
        }}
        {...menuItemProps}
      >
        {children ?? "Fusion Login Migration"}
      </ActionMenu.Item>

      <MigrationCenterDialog
        open={isOpen}
        onOpenChange={setIsOpen}
        selection={{ kind: "tenants", tenants: [tenant] }}
      />
    </>
  )
}

export default TenantMigrateMenuItem
